var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.88 172.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.62,4.1c9.03-4.52,20.32-4.52,27.1,4.52s9.03,11.29,9.03,24.84-9.03,22.58-9.03,29.35-4.52,18.06-2.26,33.87c2.26,15.81-11.29,72.26-18.06,74.51-6.77,2.26-9.03-2.26-9.03-11.29,0-9.03-2.26-40.64-4.52-47.42-2.26-6.77-9.03-15.81-13.55-2.26-4.52,13.55-6.77,49.68-6.77,51.93s-2.26,11.29-9.03,0c-6.77-11.29-20.32-33.87-18.06-54.19s4.52-33.87,0-42.9l-4.52-9.03S-2.12,33.45,2.39,22.16C6.91,10.87,18.2,1.84,31.75,4.1s24.84,4.52,33.87,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m81.42,71.84s-38.39,4.52-58.71,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m81.42,22.16s-2.26-4.52-11.29-2.26c-9.03,2.26-18.06,2.26-18.06,6.77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m52.07,13.13s4.52,11.29-13.55,6.77c-18.06-4.52-20.32,4.52-20.32,4.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth17);
export default __webpack_public_path__ + "static/media/tooth-17.2fbf564b47e6e283c47450124a8f261e.svg";
export { ForwardRef as ReactComponent };